import { IconButton } from "@material-ui/core";
import { KeyboardBackspaceOutlined } from "@material-ui/icons";
import React from "react";

const BackButton = ({ onClick }) => {
  return (
    <IconButton
      className="text-pd-black p-0 h-48 w-48 items-center justify-center"
      onClick={onClick}
      size="medium"
      sx={{}}
    >
      <KeyboardBackspaceOutlined className="h-36 w-36 p-4" color="inherit" />
    </IconButton>
  );
};

export default BackButton;
